const enum AskAidenAccess {
  NoAccess = 0,
  PromptsAccess = 1,
  FullAccess = 2
}

export default AskAidenAccess;